(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-menu-thumbnail"] && !Shopify.designMode) return;
  try {
    document.addEventListener('error', function(event) {
  var image = event.target;
  if (!image || !image.classList || !image.classList.contains('pm-menu-thumb__image')) return;
  var tile = image.closest('.pm-menu-thumb');
  if (tile) tile.classList.remove('pm-menu-thumb--image');
  image.remove();
}, true);
  } catch(e) { console.error(e); }
})();

})();
